import { getContext } from '@/context';

/**
 * Closes the miniapp. If the URL includes "gen-ai", navigates to /create before closing.
 * Uses SDK location.dispatch to change the URL and handlers.close to close the miniapp.
 */
export async function closeMiniapp(): Promise<void> {
  try {
    const context = getContext();
    const { route } = context.general.location.getState();

    // Only navigate to /create if route includes "gen-ai"
    if (route.includes('gen-ai')) {
      getContext().handlers.navigate('/create', undefined, undefined);
      return;
    }

    // Close the miniapp
    await context.handlers.close();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[closeMiniapp] Failed to close miniapp:', error);
  }
}
